import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "settings-page" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import store from "@/store";

import { PanelTheme } from "@/common/themes";
import { baseAvatar, baseConfirm, tabMenu } from "@/common/components";

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createVNode(_unref(PanelTheme), null, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode(" CONFIG ", -1)
      ]))]),
      _: 1
    })
  ]))
}
}

})